var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"ml-2",attrs:{"color":"info","href":"https://dl.equinox.io/ngrok/ngrok-link/stable","target":"_blank"}},[_vm._v(" Download NGROK "),_c('v-divider',{staticClass:"mx-6",attrs:{"vertical":""}}),_c('v-icon',[_vm._v("mdi-cloud-download-outline")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }